import {
  DataStoreModel,
  ModelTypes,
} from '../../dataStorePersistence/DataStoreModel';
import { Translator } from '../translator.interface';
import { Conneqt, ConneqtBackend } from './conneqt.interfaces';

export class ConneqtTranslator implements Translator<ConneqtBackend, Conneqt> {
  translateOneToBackendModel(resource: Conneqt): ConneqtBackend {
    // TODO: validate model
    return {
      requestAccountType: resource.accountType,
      approvedUserId: resource.createdByUserId,
      // above are different
      id: resource.id,
      modelType: ModelTypes.Conneqt,
      accountId: resource.accountId,
      accountName: resource.accountName,
      requestUserId: resource.requestUserId,
      requestUserEmail: resource.requestUserEmail,
      requestAccountEmail: resource.requestAccountEmail,
      requestPlayerId: resource.requestPlayerId,
      requestPlayerClues: resource.requestPlayerClues,
      status: resource.status,
      responseAccountId: resource.responseAccountId,
      responseAccountType: resource.responseAccountType,
      responseAccountName: resource.responseAccountName,
      responsePlayerId: resource.responsePlayerId,
      responsePlayerClues: resource.responsePlayerClues,
      responseEmail: resource.responseEmail,
      approvedAt: resource.approvedAt,
      approvedUserFullName: resource.approvedUserFullName,
      disconnectedAccountId: resource.disconnectedAccountId,
      disconnectedAccountName: resource.disconnectedAccountName,
      disconnectedAt: resource.disconnectedAt,
      disconnectedUserFullName: resource.disconnectedUserFullName,
      disconnectedUserId: resource.disconnectedUserId,
    };
  }

  translatePartialToBackendModel(
    resource: Conneqt,
  ): Partial<ConneqtBackend> & Required<DataStoreModel> {
    const allProps = this.translateOneToBackendModel(resource);
    const partialProps: Partial<ConneqtBackend> & Required<DataStoreModel> = {
      id: resource.id,
      modelType: ModelTypes.Conneqt,
    };
    Object.keys(resource).forEach((key) => {
      partialProps[key] = allProps[key];
    });
    return partialProps;
  }

  translate(resources: ConneqtBackend[]): Conneqt[] {
    // TODO: validate model
    return resources.map((resource) => {
      return this.translateOne(resource);
    });
  }
  translateOne(resource: ConneqtBackend): Conneqt {
    return {
      requestAccountType: resource.requestAccountType,
      createdByUserId: resource.approvedUserId,
      // above are different
      id: resource.id,
      modelType: ModelTypes.Conneqt,
      accountId: resource.accountId,
      accountName: resource.accountName,
      requestUserId: resource.requestUserId,
      requestUserEmail: resource.requestUserEmail,
      requestAccountEmail: resource.requestAccountEmail,
      requestPlayerId: resource.requestPlayerId,
      requestPlayerClues: resource.requestPlayerClues,
      status: resource.status,
      responseAccountId: resource.responseAccountId,
      responseAccountType: resource.responseAccountType,
      responsePlayerId: resource.responsePlayerId,
      responsePlayerClues: resource.responsePlayerClues,
      responseEmail: resource.responseEmail,
      approvedAt: resource.approvedAt,
      approvedUserFullName: resource.approvedUserFullName,
      disconnectedAccountId: resource.disconnectedAccountId,
      disconnectedAccountName: resource.disconnectedAccountName,
      disconnectedAt: resource.disconnectedAt,
      disconnectedUserFullName: resource.disconnectedUserFullName,
      disconnectedUserId: resource.disconnectedUserId,
    };
  }
}
